import { render, staticRenderFns } from "./SlideOverPanelTrigger.vue?vue&type=template&id=260b8166&"
import script from "./SlideOverPanelTrigger.vue?vue&type=script&lang=js&"
export * from "./SlideOverPanelTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports